import React from 'react';

import { getSize, Size } from './utils';

type IconType = 'filled' | 'stroke';

interface Props {
    type: IconType;
    color: string;
    size?: Size;
}

export const CheckIcon: React.FC<Props> = ({ color, size = 's', type }) => {
    const sizePx = getSize(size);

    switch (type) {
        case 'filled':
            return (
                <svg width={sizePx} height={sizePx} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-4.836-4.247a1 1 0 00-1.411.083l-5.267 5.925-2.251-2.44a1 1 0 00-1.47 1.357l2.626 2.845a1.5 1.5 0 002.12.085l.053-.052a2.27 2.27 0 00.05-.054l5.633-6.338a1 1 0 00-.083-1.411z"
                        fill={color}
                    />
                </svg>
            );
        case 'stroke':
            return (
                <svg width={sizePx} height={sizePx} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.716.386a1 1 0 011.572 1.236L8.665 15.136a1.501 1.501 0 01-2.324.042L1.237 9.146a1 1 0 111.526-1.292l4.708 5.564L17.716.386z"
                        fill={color}
                    />
                </svg>
            );
    }
};
